import { Routes } from '@angular/router';
import { LoginComponent } from './login/login-component';
import { SalesFunnelLayout } from './sales-funnel-layout.component';
import { SalesFunnelComponent } from './sales-funnel/sales-funnel-component';
import { PackageOfferComponent } from './package-offer/package-offer-component';
import { CustomerDetailsComponent } from './customer-details/customer-details-component';
import { CustomerOfferComponent } from './customer-offer/customer-offer-component';
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation-component';
import { ContractsComponent } from './contracts/contracts-component';
import { AuthGuard } from './auth-guard';

export const routes: Routes = [
  { path: '', component: LoginComponent },
  {
    path: '', component: SalesFunnelLayout, children: [
      { path: 'sales-funnel', component: SalesFunnelComponent, canActivate: [AuthGuard] },
      { path: 'package-offer', component: PackageOfferComponent, canActivate: [AuthGuard] },
      { path: 'customer-details', component: CustomerDetailsComponent, canActivate: [AuthGuard] },
      { path: 'customer-offer', component: CustomerOfferComponent, canActivate: [AuthGuard] },
      { path: 'order-confirmation', component: OrderConfirmationComponent, canActivate: [AuthGuard] },
    ]
  },
  { path: 'contracts', component: ContractsComponent, canActivate: [AuthGuard] },
  { path: 'map', loadComponent: () => import('./map/map-component').then(m => m.MapComponent), canActivate: [AuthGuard] }
];
